import React, { useState, useEffect } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  // Detect which section is currently in view
  useEffect(() => {
    const sections = ['home', 'packages', 'gallery', 'contact'];
    
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 100; // Offset for fixed header

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;
          
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on initial load

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const yOffset = -80;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
    setIsMenuOpen(false);
  };

  const isActive = (section) => activeSection === section;

  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          <div className="logo">
            <h1>Yolani's Photoshoot</h1>
          </div>
          
          <button 
            className="menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            ☰
          </button>

          <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <li>
              <a 
                href="#home" 
                className={isActive('home') ? 'active' : ''}
                onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}
              >
                Home
              </a>
            </li>
            <li>
              <a 
                href="#packages" 
                className={isActive('packages') ? 'active' : ''}
                onClick={(e) => { e.preventDefault(); scrollToSection('packages'); }}
              >
                Packages
              </a>
            </li>
            <li>
              <a 
                href="#gallery" 
                className={isActive('gallery') ? 'active' : ''}
                onClick={(e) => { e.preventDefault(); scrollToSection('gallery'); }}
              >
                Gallery
              </a>
            </li>
            <li>
              <a 
                href="#contact" 
                className={isActive('contact') ? 'active' : ''}
                onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}
              >
                Contact
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;